var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview-container"},[_c('div',{staticClass:"content",attrs:{"id":"preview-content"}})])
}]

export { render, staticRenderFns }